import {getPaymentInfo, getAccountInfo } from "./firebaseConn"
import { Timestamp } from 'firebase/firestore'
import { getUserData } from "../authUtils";


export const getUPI = () => {return getPaymentInfo()};

export const getAccount = () => {return getAccountInfo()};